import React, { useState } from "react";

import InstanceTransformInspector from "../definition-editor/InstanceTransformInspector";
import InstanceParameterOverridesInspector from "../definition-editor/InstanceParameterOverridesInspector";

function Section({ title, description, children, defaultOpen = true }) {
  return (
    <details className="border rounded bg-white" open={defaultOpen}>
      <summary className="px-3 py-2 cursor-pointer bg-slate-50 border-b">
        <div className="font-semibold text-sm text-slate-800">{title}</div>
        {description && (
          <div className="text-xs text-slate-500">{description}</div>
        )}
      </summary>

      <div className="p-3">{children}</div>
    </details>
  );
}

function SelectionInfo({ selectedNode, resolvedNode }) {
  if (!resolvedNode && !selectedNode) {
    return (
      <div className="border rounded p-4 bg-slate-50 text-sm text-slate-500">
        Select an element for advanced editing.
      </div>
    );
  }

  const node = resolvedNode || selectedNode;

  return (
    <div className="border rounded p-3 bg-white">
      <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">
        Advanced target
      </div>

      <div className="font-semibold text-sm text-slate-800">
        {node?.name || node?.id}
      </div>

      <div className="text-xs text-slate-500">
        {node?.category || node?.definition?.category || node?.nodeType || ""}
      </div>

      {resolvedNode?.parentGeneratedFromId && (
        <div className="mt-2 rounded border border-amber-100 bg-amber-50 px-2 py-1 text-xs text-amber-800">
          Generated element. Changes may be stored on parent cabinet.
        </div>
      )}
    </div>
  );
}

export default function AdvancedPropertiesPanel({
  selectedNode,
  resolvedNode,
  onChangeNode,
}) {
  const [showRaw, setShowRaw] = useState(false);

  const targetNode = selectedNode || resolvedNode;

  return (
    <div className="space-y-4">
      <SelectionInfo
        selectedNode={selectedNode}
        resolvedNode={resolvedNode}
      />

      <Section
        title="Transform"
        description="Precise position, rotation and placement."
        defaultOpen
      >
        <InstanceTransformInspector
          node={targetNode}
          resolvedNode={resolvedNode}
          onChange={onChangeNode}
        />
      </Section>

      <Section
        title="Parameter overrides"
        description="Advanced instance-level parameter changes."
        defaultOpen={false}
      >
        <InstanceParameterOverridesInspector
          node={selectedNode}
          resolvedNode={resolvedNode}
          onChange={onChangeNode}
        />
      </Section>

      <Section
        title="Raw selection"
        description="Quick inspection of current selected data."
        defaultOpen={false}
      >
        <button
          type="button"
          onClick={() => setShowRaw((prev) => !prev)}
          className="px-3 py-2 border rounded bg-white text-sm"
        >
          {showRaw ? "Hide JSON" : "Show JSON"}
        </button>

        {showRaw && (
          <pre className="mt-3 text-xs p-3 rounded bg-slate-950 text-slate-100 overflow-auto max-h-[420px]">
            {JSON.stringify(
              {
                selectedNode,
                resolvedNode,
              },
              null,
              2
            )}
          </pre>
        )}
      </Section>
    </div>
  );
}